export const Panels = {
  InventoryInstance: 'InventoryInstance',
  BackupJobsCard: 'BackupJobsCard',
  ClassificationJobsCard: 'ClassificationJobsCard',
  RestoreJobsCard: 'RestoreJobsCard',
  RestoreVolumeWizard: 'RestoreVolumeWizard',
  RestoreEc2InstanceWizard: 'RestoreEc2InstanceWizard',
  RestoreFromTemplateWizard: 'RestoreFromTemplateWizard',
  RestoreFileWizard: 'RestoreFileWizard',
  RestoreRDSWizard: 'RestoreRDSWizard',
  RestoreRDSPitrWizard: 'RestoreRDSPitrWizard',
  RestoreDynamoWizard: 'RestoreDynamoWizard',
  RestoreKeyspacesWizard: 'RestoreKeyspacesWizard',
  RestoreS3Wizard: 'RestoreS3Wizard',
  RestoreMongoAtlasWizard: 'RestoreMongoAtlasWizard',
  RestoreAzureVMWizard: 'RestoreAzureVMWizard',
  RestoreAzureVMPitrWizard: 'RestoreAzureVMPitrWizard',
  RestoreAzureDiskWizard: 'RestoreAzureDiskWizard',
  RestoreEksNamespaceWizard: 'RestoreEksNamespaceWizard',
  RestoreAzureSqlDBWizard: 'RestoreAzureSqlDBWizard',
  RestoreAzureSqlDatabaseNativePitrWizard:
    'RestoreAzureSqlDatabaseNativePitrWizard',
  RestoreAzurePostgresWizard: 'RestoreAzurePostgresWizard',
  RestoreAzureFileShareWizard: 'RestoreAzureFileShareWizard',
  CreateBackupVault: 'CreateBackupVault',
  BackupPolicyConfig: 'BackupPolicyConfig',
  ClassificationPolicyConfig: 'ClassificationPolicyConfig',
  CustomRole: 'CustomRole',
  NotificationPolicy: 'NotificationPolicy',
  Integration: 'Integration',
  SAML: 'SAML',
  Filters: 'Filters',
  Control: 'Control',
  RecreateAccountRoleAWSPanel: 'RecreateAccountRoleAWSPanel',
  RecreateAccountRoleGCPPanel: 'RecreateAccountRoleGCPPanel',
  ConnectAwsVaultAccount: 'ConnectAwsVaultAccount',
  ConvertToAMIWizard: 'ConvertToAMIWizard',
  RestoreServerConnectivityPanel: 'RestoreServerConnectivityPanel',
  RestoreServerTagsPanel: 'RestoreServerTagsPanel',
  MetricsPanel: 'MetricsPanel',
  ConvertToMultipleEonSnapshots: 'ConvertToMultipleEonSnapshots',
  ConvertToSingleEonSnapshot: 'ConvertToSingleEonSnapshot',
  ObjectStoreBackupConfiguration: 'ObjectStoreBackupConfiguration',
  RestoreGcpVMWizard: 'RestoreGcpVMWizard',
  RestoreGcpDiskWizard: 'RestoreGcpDiskWizard',
  RestoreGcpCloudSqlWizard: 'RestoreGcpCloudSqlWizard',
  RestoreBigQueryWizard: 'RestoreBigQueryWizard',
  RestoreFSxWizard: 'RestoreFSxWizard',
  RestoreEFSWizard: 'RestoreEFSWizard',
  RestoreDocumentdbWizard: 'RestoreDocumentdbWizard',
  RestoreNeptuneWizard: 'RestoreNeptuneWizard',
  UpdateAccountAWSPanel: 'UpdateAccountAWSPanel',
  UpdateAccountGCPPanel: 'UpdateAccountGCPPanel',
  UpdateAccountAzurePanel: 'UpdateAccountAzurePanel',
  ThreatConditionPanel: 'ThreatByConditionPanel',
  BackupScopeResourcesPanel: 'BackupScopeResourcesPanel',
  AzureOwnCloudOnboardingWizard: 'AzureOwnCloudOnboardingWizard',
  AzureOnboardingWizard: 'AzureOnboardingWizard',
  AzureConnectRestoreWizard: 'AzureConnectRestoreWizard',
  AzureConnectSourceWizard: 'AzureConnectSourceWizard',
  AzureConnectTenantWizard: 'AzureConnectTenantWizard',
  GcpConnectAccountWizard: 'GcpConnectAccountWizard',
  MongoAtlasConnectSourceWizard: 'MongoAtlasConnectSourceWizard',
  MongoAtlasConnectRestoreWizard: 'MongoAtlasConnectRestoreWizard',
  ConfigureGwsRestoreWizard: 'ConfigureGwsRestoreWizard',
  ConfigureM365RestoreWizard: 'ConfigureM365RestoreWizard',
  MongoAtlasPrivateLinkWizard: 'MongoAtlasPrivateLinkWizard',
  RestoreMongoAtlasPrivateLinkWizard: 'RestoreMongoAtlasPrivateLinkWizard',
  AwsConnectAccountWizard: 'AwsConnectAccountWizard',
  StorageGatewayWizard: 'StorageGatewayWizard',
  ConfigureProjectLimitsWizard: 'ConfigureProjectLimitsWizard',
  LogSpaceRecordCard: 'LogSpaceRecordCard',
  DataKnowledgeGraphTable: 'DataKnowledgeGraphTable',
  DataKnowledgeGraphSemanticLayer: 'DataKnowledgeGraphSemanticLayer',
  BackupZeroEtlPolicyConfig: 'BackupZeroEtlPolicyConfig',
  RdsCdcWizard: 'RdsCdcWizard',
  RestoreGoogleWorkspaceWizard: 'RestoreGoogleWorkspaceWizard',
  RestoreMicrosoft365Wizard: 'RestoreMicrosoft365Wizard',
  ConnectSaasWorkspaceWizard: 'ConnectSaasWorkspaceWizard',
  ConnectM365Wizard: 'ConnectM365Wizard',
  RestoreM365Wizard: 'RestoreM365Wizard',
  ExportAccessDeniedItemsWizard: 'ExportAccessDeniedItemsWizard',
  ManageApprovalRules: 'ManageApprovalRules',
  RestoreTemplatesSidePanel: 'RestoreTemplatesSidePanel',
  BulkRestore: 'BulkRestore',
} as const;

export type Panels = (typeof Panels)[keyof typeof Panels];
